"use client";

import React from "react";
import EditSection, {
  TextEditor,
  ListItemEditor,
} from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function HokFeaturesEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <>
          {/* Section Header */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Header</h4>
            <TextEditor
              label="Subtitle"
              value={content.subtitle}
              onChange={(v) => handleChange({ ...content, subtitle: v })}
              placeholder="Our Features"
            />
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => handleChange({ ...content, title: v })}
              placeholder="Powerful AI Features"
            />
          </div>

          {/* Features Cards */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Features List</h4>
            <ListItemEditor
              label="Feature Items (Staggered Layout)"
              items={content.items || [
                {
                  title: "User-Friendly Platforms",
                  description: "All the Lorem Ipsum generators on the Internet tend to repeat predefined necessary.",
                  icon: "/assets/img/icon/service_1_1.svg",
                },
                {
                  title: "Seamless Experience",
                  description: "All the Lorem Ipsum generators on the Internet tend to repeat predefined necessary.",
                  icon: "/assets/img/icon/service_1_2.svg",
                },
                {
                  title: "24/7 Support",
                  description: "All the Lorem Ipsum generators on the Internet tend to repeat predefined necessary.",
                  icon: "/assets/img/icon/service_1_3.svg",
                },
                {
                  title: "Problem Solving",
                  description: "All the Lorem Ipsum generators on the Internet tend to repeat predefined necessary.",
                  icon: "/assets/img/icon/service_1_4.svg",
                },
                {
                  title: "We are open source",
                  description: "All the Lorem Ipsum generators on the Internet tend to repeat predefined necessary.",
                  icon: "/assets/img/icon/service_1_5.svg",
                },
                {
                  title: "Secure Transactions",
                  description: "All the Lorem Ipsum generators on the Internet tend to repeat predefined necessary.",
                  icon: "/assets/img/icon/service_1_6.svg",
                },
                {
                  title: "Top Resources",
                  description: "All the Lorem Ipsum generators on the Internet tend to repeat predefined necessary.",
                  icon: "/assets/img/icon/service_1_7.svg",
                },
              ]}
              itemSchema={[
                { key: "title", label: "Title", type: "text" },
                { key: "description", label: "Description", type: "textarea" },
              ]}
              onChange={(items) => handleChange({ ...content, items: items })}
              addItemText="Add Feature"
            />
          </div>

          {/* Bottom Action */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Call to Action</h4>
            <div className="flex items-center gap-2 py-1">
              <input
                type="checkbox"
                id="showCta"
                checked={content.showCta !== false}
                onChange={(e) => handleChange({ ...content, showCta: e.target.checked })}
                className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
              />
              <label htmlFor="showCta" className="text-xs font-medium text-gray-700 cursor-pointer">
                Show Call to Action Button
              </label>
            </div>
            {content.showCta !== false && (
              <>
                <TextEditor
                  label="Button Text"
                  value={content.ctaText}
                  onChange={(v) => handleChange({ ...content, ctaText: v })}
                  placeholder="View All Features"
                />
                <TextEditor
                  label="Button Link / URL"
                  value={content.ctaUrl || ""}
                  onChange={(v) => handleChange({ ...content, ctaUrl: v })}
                  placeholder="/features or https://..."
                  multiline
                />
              </>
            )}
          </div>
        </>
      }
    />
  );
}
